var _path, _mask, _g, _path2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.702 153.216C408.772 145.335 398.214 141 387 141C375.786 141 365.245 145.335 357.314 153.216C349.367 161.097 345 171.572 345 182.721C345 193.87 349.367 204.345 357.314 212.226C365.245 220.091 375.786 224.442 387 224.442C398.214 224.442 408.755 220.107 416.686 212.226C424.633 204.345 429 193.87 429 182.721C429 171.572 424.633 161.097 416.702 153.216ZM419.773 169.323H404.191C404.174 169.274 404.174 169.224 404.158 169.175C402.647 161.015 400.431 154.152 398.707 149.538C408.246 152.855 415.931 160.112 419.773 169.323ZM382.255 147.896C383.815 147.683 385.391 147.584 387 147.584C388.33 147.584 389.627 147.666 390.908 147.798C392.32 151.065 395.489 159.11 397.492 169.323H377.165C378.873 157.961 381.713 149.472 382.255 147.896ZM351.568 182.721C351.568 180.389 351.798 178.107 352.241 175.891H369.76C369.152 182.475 369.103 188.812 369.612 194.773H353.719C352.323 191.013 351.568 186.957 351.568 182.721ZM356.97 201.34H370.433C371.254 206.348 372.486 211.077 374.16 215.461C367.018 212.702 360.992 207.694 356.97 201.34ZM370.532 169.323H354.244C358.02 160.276 365.491 153.134 374.768 149.735C373.536 153.938 371.73 160.884 370.532 169.323ZM391.729 217.546C390.185 217.743 388.609 217.858 387.016 217.858C385.375 217.858 383.766 217.743 382.173 217.529C379.677 212.341 378.068 206.841 377.116 201.34H397.82C396.654 206.808 394.717 212.308 391.729 217.546ZM398.838 194.773H376.229C375.622 188.057 375.819 181.572 376.36 175.891H398.559C399.282 181.588 399.561 188.074 398.838 194.773ZM400.185 215.346C402.122 210.962 403.583 206.282 404.519 201.34H417.047C413.09 207.612 407.179 212.554 400.185 215.346ZM405.472 194.773L405.521 194.181C406.046 188.369 405.931 182.228 405.176 175.891H421.776C422.219 178.107 422.449 180.389 422.449 182.721C422.449 186.957 421.694 191.013 420.298 194.773H405.472Z",
    fill: "url(#paint0_linear_269_2)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_269_2",
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 175,
    width: 230,
    height: 159,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 112,
    y: 175,
    width: 230,
    height: 159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.719 183.812L179.031 231.273L198.367 183.812H229.91L195.633 254.223L230.594 326H197.781L177.566 277.465L157.352 326H125.223L160.77 253.637L126.004 183.812H158.719ZM333.621 302.367V326H249.051V302.367H333.621ZM332.547 200.512L261.551 326H241.531V308.715L313.406 183.812H332.547V200.512ZM322.879 183.812V207.543H240.945V183.812H322.879Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_269_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.719 183.812L179.031 231.273L198.367 183.812H229.91L195.633 254.223L230.594 326H197.781L177.566 277.465L157.352 326H125.223L160.77 253.637L126.004 183.812H158.719ZM333.621 302.367V326H249.051V302.367H333.621ZM332.547 200.512L261.551 326H241.531V308.715L313.406 183.812H332.547V200.512ZM322.879 183.812V207.543H240.945V183.812H322.879Z",
    fill: "url(#paint1_linear_269_2)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.719 183.812L166.073 180.665L163.997 175.812H158.719V183.812ZM179.031 231.273L171.677 234.421L179.213 252.031L186.44 234.292L179.031 231.273ZM198.367 183.812V175.812H192.988L190.958 180.794L198.367 183.812ZM229.91 183.812L237.103 187.314L242.702 175.812H229.91V183.812ZM195.633 254.223L188.44 250.721L186.735 254.224L188.441 257.726L195.633 254.223ZM230.594 326V334H243.389L237.786 322.497L230.594 326ZM197.781 326L190.396 329.076L192.447 334H197.781V326ZM177.566 277.465L184.951 274.389L177.566 256.658L170.181 274.389L177.566 277.465ZM157.352 326V334H162.686L164.737 329.076L157.352 326ZM125.223 326L118.042 322.473L112.38 334H125.223V326ZM160.77 253.637L167.95 257.164L169.694 253.613L167.931 250.071L160.77 253.637ZM126.004 183.812V175.812H113.084L118.842 187.378L126.004 183.812ZM151.364 186.96L171.677 234.421L186.386 228.126L166.073 180.665L151.364 186.96ZM186.44 234.292L205.776 186.831L190.958 180.794L171.623 228.255L186.44 234.292ZM198.367 191.812H229.91V175.812H198.367V191.812ZM222.717 180.311L188.44 250.721L202.826 257.724L237.103 187.314L222.717 180.311ZM188.441 257.726L223.402 329.503L237.786 322.497L202.825 250.72L188.441 257.726ZM230.594 318H197.781V334H230.594V318ZM205.166 322.924L184.951 274.389L170.181 280.541L190.396 329.076L205.166 322.924ZM170.181 274.389L149.967 322.924L164.737 329.076L184.951 280.541L170.181 274.389ZM157.352 318H125.223V334H157.352V318ZM132.403 329.527L167.95 257.164L153.589 250.109L118.042 322.473L132.403 329.527ZM167.931 250.071L133.165 180.247L118.842 187.378L153.608 257.202L167.931 250.071ZM126.004 191.812H158.719V175.812H126.004V191.812ZM333.621 302.367H341.621V294.367H333.621V302.367ZM333.621 326V334H341.621V326H333.621ZM249.051 326H241.051V334H249.051V326ZM249.051 302.367V294.367H241.051V302.367H249.051ZM332.547 200.512L339.51 204.451L340.547 202.618V200.512H332.547ZM261.551 326V334H266.216L268.514 329.939L261.551 326ZM241.531 326H233.531V334H241.531V326ZM241.531 308.715L234.597 304.725L233.531 306.577V308.715H241.531ZM313.406 183.812V175.812H308.78L306.472 179.822L313.406 183.812ZM332.547 183.812H340.547V175.812H332.547V183.812ZM322.879 183.812H330.879V175.812H322.879V183.812ZM322.879 207.543V215.543H330.879V207.543H322.879ZM240.945 207.543H232.945V215.543H240.945V207.543ZM240.945 183.812V175.812H232.945V183.812H240.945ZM325.621 302.367V326H341.621V302.367H325.621ZM333.621 318H249.051V334H333.621V318ZM257.051 326V302.367H241.051V326H257.051ZM249.051 310.367H333.621V294.367H249.051V310.367ZM325.584 196.572L254.588 322.061L268.514 329.939L339.51 204.451L325.584 196.572ZM261.551 318H241.531V334H261.551V318ZM249.531 326V308.715H233.531V326H249.531ZM248.465 312.705L320.34 187.803L306.472 179.822L234.597 304.725L248.465 312.705ZM313.406 191.812H332.547V175.812H313.406V191.812ZM324.547 183.812V200.512H340.547V183.812H324.547ZM314.879 183.812V207.543H330.879V183.812H314.879ZM322.879 199.543H240.945V215.543H322.879V199.543ZM248.945 207.543V183.812H232.945V207.543H248.945ZM240.945 191.812H322.879V175.812H240.945V191.812Z",
    fill: "url(#paint2_linear_269_2)",
    mask: "url(#path-2-outside-1_269_2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 255.5,
    r: 217.5,
    stroke: "url(#paint3_linear_269_2)",
    strokeWidth: 20
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_269_2",
    x: 125.223,
    y: 183.812,
    width: 208.398,
    height: 146.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_269_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_2",
    x1: 387,
    y1: 141,
    x2: 387,
    y2: 224.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_269_2",
    x1: 129.5,
    y1: 186,
    x2: 323.5,
    y2: 326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4901,
    stopColor: "#323232",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_269_2",
    x1: 114,
    y1: 178.5,
    x2: 338,
    y2: 332.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_269_2",
    x1: 128,
    y1: 70.5,
    x2: 411,
    y2: 427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXzLogo);
export default __webpack_public_path__ + "static/media/XZ_LOGO.b127699430d92c75ac70b2b86745ec1f.svg";
export { ForwardRef as ReactComponent };